var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inventory_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6 1.8H3.8C3 1.8 2.2 2.52 2.2 3.4V5.808C2.2 6.384 2.544 6.88 3 7.16V16.2C3 17.08 3.88 17.8 4.6 17.8H15.8C16.52 17.8 17.4 17.08 17.4 16.2V7.16C17.856 6.88 18.2 6.384 18.2 5.808V3.4C18.2 2.52 17.4 1.8 16.6 1.8ZM15.8 16.2H4.6V7.4H15.8V16.2ZM16.6 5.8H3.8V3.4H16.6V5.8Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 9.8H7.8V11.4H12.6V9.8Z",
    fill: "#343333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveList);
export default __webpack_public_path__ + "static/media/archive-list.2926b3807cf43d3de600f62efff3eb37.svg";
export { ForwardRef as ReactComponent };